// extracted by mini-css-extract-plugin
export default {"wrapper":"Projects_wrapper__2hsnr","projectsBlock":"Projects_projectsBlock__Isd8q","allProjectsBlock":"Projects_allProjectsBlock__D6MRL","mySwiper":"Projects_mySwiper__u2vH0"};